"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Button_1 = require("@material-ui/core/Button");
var FormHelperText_1 = require("@material-ui/core/FormHelperText");
var Grid_1 = require("@material-ui/core/Grid");
var TextField_1 = require("@material-ui/core/TextField");
var withStyles_1 = require("@material-ui/styles/withStyles");
var styles_1 = require("./styles");
var CouponForm = /** @class */ (function (_super) {
    __extends(CouponForm, _super);
    function CouponForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.couponCodeInput = React.createRef();
        _this.onSubmit = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (_this.couponCodeInput.current === null) {
                throw Error('Coupon code input not associated with a form element.');
            }
            _this.props.onSubmit &&
                _this.props.onSubmit(_this.couponCodeInput.current.value);
        };
        return _this;
    }
    CouponForm.prototype.render = function () {
        var _a = this.props, classes = _a.classes, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
        return (React.createElement("form", { onSubmit: this.onSubmit, className: classes.couponCodeForm, style: { width: 'flex' } },
            React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.summaryRow },
                React.createElement(Grid_1.default, { item: true, className: classes.couponCodeCollumn },
                    React.createElement(TextField_1.default, { variant: "outlined", label: "Promo Code", name: "Promo Code", disabled: disabled, className: classes.couponCodeInput, inputProps: { ref: this.couponCodeInput }, margin: "dense" })),
                React.createElement(Grid_1.default, { item: true, className: classes.couponCodeCollumn },
                    React.createElement(Button_1.default, { className: classes.couponCodeButton, type: "submit", disabled: disabled, variant: "outlined", color: "primary" }, "Apply")),
                this.props.couponCodeError && (React.createElement(Grid_1.default, { item: true, style: { width: '100%' } },
                    React.createElement(FormHelperText_1.default, { error: true }, this.props.couponCodeError))))));
    };
    return CouponForm;
}(React.Component));
exports.default = withStyles_1.default(styles_1.default)(CouponForm);
